/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { device } from '@/constants/breakpoints';
import RecurringBills from './bill/Bills';
import RecurringInvoices from './invoice/Invoices';

const tabs = [
  {
    name: 'Recurring Bills',
    path: 'view=bills&page=1',
    value: 'bills'
  },
  {
    name: 'Recurring Invoices',
    path: 'view=invoices&page=1',
    value: 'invoices'
  }
];

function Recurring() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('view');

  return (
    <>
      <RecurringStyles>
        <ContentView>
          <h3>Manage Recurring Bills/Invoices</h3>
          <TabsView>
            {tabs.map((tabItem) => (
              <div key={tabItem.path} className="tab-item">
                <button
                  type="button"
                  className={`tab-btn ${tab === tabItem.value ? 'active' : ''}`}
                  onClick={() => setSearchParams(`tab=recurring&${tabItem?.path}`)}>
                  {tabItem.name}
                </button>
              </div>
            ))}
          </TabsView>
          <InfoView>
            {tab === 'bills' && <RecurringBills />}
            {tab === 'invoices' && <RecurringInvoices />}
          </InfoView>
        </ContentView>
      </RecurringStyles>
    </>
  );
}

export default Recurring;

export const RecurringStyles = styled.div`
  width: 100%;
  height: 100%;
  /* padding: 0 40px 0 0;
  overflow-y: scroll; */

  @media ${device.phone} {
    width: 100%;
    padding: 0;
  }
`;

export const ContentView = styled.div`
  width: 100%;
  padding: 0px 0px 0 30px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;

  @media ${device.phone} {
    padding: 20px 0px;
    padding-top: 40px;
    flex-direction: column;
  }

  h3 {
    font-size: 24px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors?.secondary};
    margin-bottom: 20px;

    @media ${device.phone} {
      font-size: 20px;
      margin-bottom: 20px;
    }
  }
`;

export const TabsView = styled.div`
  width: auto;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 30px;
  overflow-x: scroll;
  border-bottom: 2px solid ${({ theme }) => theme.colors?.layer3};

  @media ${device.phone} {
    width: 100%;
    display: flex;
    overflow-x: scroll;
    border: none;
  }

  .tab-item {
    margin-right: 10px;
    display: flex;

    @media ${device.phone} {
      margin-bottom: 0;
      margin-right: 10px;
      width: 200px;
    }

    button {
      width: fit-content;
      height: 44px;
      background-color: transparent;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      color: ${({ theme }) => theme.colors?.secondary};
      transition: all 0.3s ease-in-out;
      padding: 12px 32px;
      word-break: normal;
      white-space: nowrap;

      @media ${device.phone} {
        padding: 0;
        width: 150px;
        justify-content: center;
      }

      &:hover {
        color: ${({ theme }) => theme.colors?.secondary};
        border-bottom: 2px solid ${({ theme }) => theme.colors?.primary};
        border-radius: 0;
      }
    }

    .active {
      color: ${({ theme }) => theme.colors?.secondary};
      border-bottom: 2px solid ${({ theme }) => theme.colors?.primary};
      border-radius: 0;
    }
  }
`;

export const InfoView = styled.div`
  width: 100%;
  height: 100%;

  @media ${device.phone} {
    width: 100%;
  }
`;
